import EliminatorEnterPickItem from '../Eliminator/EliminatorEnterPickItem'
import EliminatorEnterPickGame from '../Eliminator/EliminatorEnterPickGame'
import * as styles from './TerminatorEnterPick.scss'
import moment from 'moment-timezone'
import terminatorErrorMessage from './terminatorErrorMessage'
import React, { useEffect, useRef, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Alert, Button, Row, Col, ListGroup, Spinner } from 'react-bootstrap'
import { getEnterPicks, savePick } from '@severed-links/common.redherrings-reducers/terminator'
import { createNotification } from '@severed-links/common.redherrings-reducers/notifications'
const TerminatorEnterPick = () => {
  const dispatch = useDispatch()
  const data = useSelector(state => state.terminator.enterPicks)
  const [busy, setBusy] = useState(false)
  const saving = useRef(false)
  const [message, setMessage] = useState('')
  const [loaded, setLoaded] = useState(false)
  const [now, setNow] = useState(Date.now())
  const load = async () => {
    setLoaded(false)
    try {
      const action = await dispatch(getEnterPicks())
      if (action.error || action.payload?.messageType === 'error') throw new Error(action.payload?.response?.message || action.payload?.message || 'Unable to load picks.')
      setLoaded(true)
      setMessage('')
    } catch (error) { setMessage(terminatorErrorMessage(error)) }
  }
  useEffect(() => { load(); const timer = setInterval(() => setNow(Date.now()), 1000); return () => clearInterval(timer) }, [dispatch])
  const canSave = loaded && data.canEnterPick && now < new Date(data.deadline).getTime()
  const save = async teamId => {
    if (!canSave || saving.current || Date.now() >= new Date(data.deadline).getTime()) return
    if (!data.options?.some(team => team.teamId === teamId && !team.used)) return
    saving.current = true
    setBusy(true)
    setMessage('')
    try {
      const action = await dispatch(savePick({ seasonId: data.seasonId, seasonMode: data.seasonMode, week: data.week, teamId }))
      if (action.error || action.payload?.messageType === 'error') throw new Error(action.payload?.response?.message || action.payload?.message || 'Unable to save pick.')
      dispatch(createNotification({ type: 'success', headline: 'Terminator Pick', message: action.payload.message || 'Your losing-team pick has been saved.', timeout: 6000 }))
    } catch (error) {
      dispatch(createNotification({ type: 'error', headline: 'Terminator Pick', message: terminatorErrorMessage(error), timeout: 6000 }))
    }
    setBusy(false)
    saving.current = false
  }
  return <main className={styles.container}>
    <header className={styles.heading}>
      <div className={styles.eyebrow}>Terminator</div>
      <h2 className={styles.title}>Enter Your Pick</h2>
    </header>
    {message ? <Alert variant='info'>{message}</Alert> : null}
    {!loaded ? <Button onClick={load}>Load picks</Button> : <><p>{data.seasonName} · {data.seasonMode} Week {data.week}</p><p>Deadline: {data.deadline ? new Date(data.deadline).toLocaleString() : 'Not set'}</p>
    {!canSave ? <Alert variant='info'>{data.message || 'The pick deadline has passed.'}</Alert> : null}
    <Row><Col lg={4} xs={12}><h4>Your Picks</h4><ListGroup>{(data.picks || []).map(pick => <div key={pick.weekDisplay}>
      <small>{pick.seasonMode} · {pick.weekDisplay}{pick.isCurrentPick ? ' · Current week' : ''}</small>
      <div className={styles.pickSlot} aria-busy={busy && pick.isCurrentPick}>
        <div className={busy && pick.isCurrentPick ? styles.hiddenPick : undefined} aria-hidden={busy && pick.isCurrentPick ? true : undefined}>
          <EliminatorEnterPickItem pick={pick} isCurrentPick={pick.isCurrentPick} />
        </div>
        {busy && pick.isCurrentPick ? <ListGroup.Item className={styles.savingPick} role='status'>
          <Spinner animation='border' size='sm' aria-hidden='true' />
          <span className='visually-hidden'>Saving your pick…</span>
        </ListGroup.Item> : null}
      </div>
    </div>)}</ListGroup>{!data.picks?.length ? <p>No prior picks.</p> : null}</Col>
    <Col lg={8} xs={12}><h4>This Week’s Games</h4><p>Click a team to save your pick for the team you expect to lose. Previously used teams are unavailable.</p>
    <fieldset disabled={busy || !canSave}>{(data.games || []).map((game, index) => <div key={`${game.visitor}-${game.home}`}><div>{moment(game.date).format('dddd, MMMM D, YYYY')}</div><EliminatorEnterPickGame game={game} index={index} savePick={save} /></div>)}</fieldset>
    <p>Saved pick: {data.options?.find(team => team.teamId === data.teamId)?.nflTeam || 'No pick saved'}</p>
    </Col></Row></>}
  </main>
}
export default TerminatorEnterPick
